import axios from 'axios';
import { peekToken } from '../utils/peek';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    // Active peek session: the backend scopes every request to the peeked org
    const peek = peekToken();
    if (peek) {
      config.headers['X-Peek-Context'] = peek;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const { response } = error;

    // Public, no-login pages (Trust Center, auditor portal) must never be bounced to login on a
    // 401 — they're meant for visitors without a Cataam account. Only force re-login elsewhere.
    const hash = (typeof window !== 'undefined' && window.location.hash) || '';
    const onPublicRoute = hash.includes('/trust/') || hash.includes('/auditor/');
    if (response && response.status === 401 && !onPublicRoute) {
      localStorage.removeItem('authToken');
      localStorage.removeItem('userName');
      window.location.href = '/#/login';
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
